module.exports = __webpack_public_path__ + "STOKES_FR-5U5.svg";